import { forwardRef, useContext, useMemo } from "react";
import { AppThemeContext } from "../../contexts/colors";
// import MaterialCommunityIcons from "@expo/vector-icons/MaterialCommunityIcons";
import { localeContext } from "../../contexts/localeManagement";
import TouchableOpacity from "../Custom/TouchableOpacity";
import MaterialCommunityIcons from "../Custom/MaterialCommunityIcons";

/**
 * The component for a single settings item
 */
export default forwardRef(function SettingsItem({ icon, content, color, onPress, IconComponent, secondaryText="", disabled=false }, ref) {
	const {
		dark,
		colors
	} = useContext(AppThemeContext);
	const { locale, appText } = useContext(localeContext);

	let settingsItemStyles = useMemo(() => ({
		item: {
			backgroundColor: colors().secondary,
			display: "flex",
			flexDirection: "row",
			width: "90%",
			marginLeft: "auto",
			marginRight: "auto",
			height: 60,
			justifyContent: "start",
			borderRadius: 10,
			marginBottom: 10
		},
		itemText: {
			color: colors().constantWhite,
			fontFamily: locale === "ar" ? "ArabicMainNormal" : "",
			fontWeight: locale === "ar"
				? "regular"
				: "bold",
			fontSize: 20,
			[locale ==="ar" ? "marginRight" : "marginLeft"]: 20,
			marginTop: "auto",
			marginBottom: "auto",
			textAlign: locale === "ar" ? "right" : "left"
		},
		secondaryText: {
			color: colors().thumb,
			fontFamily: locale === "ar" ? "ArabicMainNormal" : "",
			fontWeight: locale === "ar"
				? "regular"
				: "bold",
			fontSize: 15,
			marginLeft: "auto",
			// [locale ==="ar" ? "right" : "left"]: 60,
			marginTop: "auto",
			marginBottom: "auto",
			textAlign: locale === "ar" ? "right" : "left"
		},
		icon: {
			display: "flex",
			flexDirection: "column",
			// position: 'absolute',
			backgroundColor: color,
			padding: 2,
			borderRadius: 100,
			[locale ==="ar" ? "marginRight" : "marginLeft"]: 10,
			marginTop: "auto",
			marginBottom: "auto",
			width: 45,
			height: 45,
			justifyContent: "center",
			alignItems: "center"
		}
	}), [dark, locale, disabled])

	return (
		<>
			<TouchableOpacity style={settingsItemStyles.item} onPress={onPress} ref={ref} disabled={disabled}>
				{IconComponent
					? <div style={settingsItemStyles.icon}>
						<IconComponent icon={icon} size="2x" color={colors().constantWhite} />
					</div>
					: <div style={settingsItemStyles.icon}>
						<MaterialCommunityIcons name={icon} size={30} color={colors().constantWhite} />
					</div>}
				<h1 style={settingsItemStyles.itemText}>{appText[content] || content}</h1>
				{secondaryText ? <h1 style={settingsItemStyles.secondaryText}>{appText[secondaryText] || secondaryText}</h1> : null}
			</TouchableOpacity>
		</>
	);
})